import i18n from "../components/_common/i18n";

const languageSuffixes = {
    pl: ["_pl", ""],
    en: ["_en", "_ang"],
};

export const TranslationFromJson = (json, key, i18n) => {
    const currentLanguage = i18n?.language || "pl";
    if (!json) return;
    return json[key + languageSuffixes[currentLanguage].find((suffix) => json[key + suffix])] || json[key];
};

export const useTranslationFromJson = () => {
    const translationFromJson = (json, key) => TranslationFromJson(json, key, i18n);

    return { translationFromJson };
};

export default useTranslationFromJson;
